import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEnvironmentUrls } from '#shared/providers/EnvironmentUrls';
import { AccountRow } from '../types';

type AccountLogoProps = {
  account: AccountRow;
};

function getLogoSrc(account: AccountRow, embedAssetsUrl: string): string | null {
  if (account.Type === 'Bank Account') {
    return account.BankId ? `${embedAssetsUrl}/images/logos-banks/${account.BankId}.svg` : null;
  }

  return account.CreditCardBrand ? `${embedAssetsUrl}/images/${account.CreditCardBrand}.png` : null;
}

// Each logo owns its own failed flag. Hoisting it into the table keyed by row position breaks on a
// sort or a delete: the suppression follows the slot, not the image.
export default function AccountLogo({ account }: AccountLogoProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.PaymentMethodsTable' });
  const { embedAssetsUrl } = useEnvironmentUrls();
  const [hasFailedLoading, setHasFailedLoading] = useState(false);
  const src = getLogoSrc(account, embedAssetsUrl);

  if (!src || hasFailedLoading) return null;

  const alt =
    account.Type === 'Bank Account'
      ? t('bankLogoAlt', { defaultValue: 'bank logo' })
      : t('cardLogoAlt', { defaultValue: 'card logo' });

  return <img alt={alt} src={src} onError={() => setHasFailedLoading(true)} />;
}
